import { configureStore } from '@reduxjs/toolkit';
import locationReducer from '../Reducers/locationSlice';
import datetimeReducer from '../Reducers/dateTimeSlice';
import tripReducer from '../Reducers/tripSlice';
import notifyReducer from '../Reducers/notificationSlice';
import cartReducer from '../Reducers/cartSlice';
import { persistReducer, persistStore } from 'redux-persist';
import { encryptedStorage } from '../utils/encryptedStorage';
import { combineReducers } from 'redux';

const rootReducer = combineReducers({
    location: locationReducer,
    datetime: datetimeReducer,
    trip: tripReducer,
    notification: notifyReducer,
    cart: cartReducer,
});


const persistConfig = {
    key: 'root',
    storage: encryptedStorage,
    whitelist: ['trip', 'notification', 'cart'],
};

const persistedReducer = persistReducer(persistConfig, rootReducer);


export const store = configureStore({
    reducer: persistedReducer,
    middleware: (getDefaultMiddleware) =>
        getDefaultMiddleware({
            serializableCheck: false,
        }),
});

export const persistor = persistStore(store);

